// @ts-check
import { cacheKey, serialiseCache, THEME_READY_CLASS } from "./themeCache.js";

/**
 * The only runtime writer of theme variables. `target` is the document in the
 * app and a fake in tests.
 *
 * @param {{
 *   root: { style: { setProperty: (name: string, value: string) => void, removeProperty: (name: string) => void }, classList: { add: (name: string) => void } },
 *   origin: string,
 *   storage: { setItem: (key: string, value: string) => void },
 *   setThemeColor?: (color: string) => void,
 *   appliedKeys?: string[],
 * }} target
 * @param {Record<string, string>} vars
 * @param {string} themeId
 */
export function applyTheme(target, vars, themeId) {
  const prior = Array.isArray(target.appliedKeys) ? target.appliedKeys : [];
  for (const key of prior) {
    if (!Object.hasOwn(vars, key)) target.root.style.removeProperty(key);
  }
  for (const key of Object.keys(vars)) target.root.style.setProperty(key, vars[key]);
  target.appliedKeys = Object.keys(vars);
  const nav = vars["--nav-bg"];
  if (typeof nav === "string" && target.setThemeColor) target.setThemeColor(nav);
  target.root.classList.add(THEME_READY_CLASS);
  try {
    target.storage.setItem(cacheKey(target.origin), serialiseCache(themeId, vars));
  } catch {
    // Quota and private mode both throw. The paint already happened.
  }
}
